import baseAPI from "@/api/base";
import {
  CREATE_CHECKOUT_URL,
  GET_PLAN_CATALOG_URL,
  GET_STRIPE_BILLING_PORTAL_URL,
  GET_STRIPE_SESSION_INFO_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";
import { v4 as uuidv4 } from "uuid";

class Subscription {
  static createCheckout = async (priceId: string, promoCode?: string): Promise<AxiosResponse> => {
    const query = new URLSearchParams({ requestId: uuidv4() });
    if (promoCode) query.set("promoCode", promoCode);
    const response: AxiosResponse = await baseAPI.get(`${CREATE_CHECKOUT_URL}/${priceId}?${query}`);
    return response;
  };

  static getStripeSessionInfo = async (sessionId: String): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(
      `${GET_STRIPE_SESSION_INFO_URL}/${sessionId}`
    );
    return response;
  };

  static getStripeBillingPortalURL = async (
    flow?: "payment_method_update"
  ): Promise<AxiosResponse> => {
    const url = flow
      ? `${GET_STRIPE_BILLING_PORTAL_URL}?flow=${encodeURIComponent(flow)}`
      : GET_STRIPE_BILLING_PORTAL_URL;
    const response: AxiosResponse = await baseAPI.get(url);
    return response;
  };

  static getPlanCatalog = async (): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PLAN_CATALOG_URL);
    return response;
  };
}

export default Subscription;
